import type {ItemLayouts} from '@wix/document-services-types'
import {isEmpty} from 'lodash'
import type {CalculateParams} from '../types'
import {convertYToPx} from '../converters/y'
import {isPage, isSection} from '../utils'

export const calculateY = (calculateParams: CalculateParams): void => {
    const {measurementsMapAPI, extensionAPI, compRef, layoutData} = calculateParams
    const {get, set} = measurementsMapAPI
    if (get.y(compRef) !== undefined) {
        return
    }

    if (isSection(extensionAPI, compRef) || isPage(extensionAPI, compRef)) {
        set.y(compRef, 0)
        return
    }

    const itemLayout = layoutData.itemLayout as ItemLayouts
    if (!itemLayout || isEmpty(itemLayout)) {
        set.y(compRef, 0)
        return
    }

    let y = 0

    switch (itemLayout.type) {
        case 'GridItemLayout':
        case 'FixedItemLayout': {
            y = convertYToPx.alignSelf({...calculateParams, value: itemLayout})
            break
        }
        case 'FlexItemLayout':
        case 'OrganizerItemLayout':
        case 'StackItemLayout':
        default: {
            y = 0
            break
        }
    }

    set.y(compRef, y)
}
